export function compressImage(inputUrl, ratio)
{
  let inImg = new Image();
  inImg.src = inputUrl;

  let canvas = document.createElement('canvas');

  return new Promise((resolve, reject) =>
  {
    const resize = () => {
      canvas.width  = Math.min(2100, inImg.naturalWidth);
      canvas.height = Math.min(2970, inImg.naturalHeight);

      let ratioHeight = canvas.width/inImg.naturalWidth * inImg.naturalHeight;

      let context = canvas.getContext('2d');
      context.drawImage(inImg,
        0,0,inImg.naturalWidth,inImg.naturalHeight,
        0,0,canvas.width,ratioHeight
      );

      let outputUrl = canvas.toDataURL('image/jpeg', ratio || 1);
      resolve(outputUrl);
    }

    inImg.onload = resize;
  });
}

export function extractBase64(dataUrl)
{
  return dataUrl.split(';base64,')[1];
}